import React from "react";
import styled from "styled-components";
import { primaryGradient } from "../GradientBox";
import {
  desktopQuery,
  DeviceWidth,
  mobileQuery,
  useDeviceWidthQuery,
} from "../MediaQuery";
import { translation } from "../translations";
import { SlantedSection } from "./SlantedSection";

export const BenefitsSection: React.FC = () => (
  <Layout>
    <Wrapper>
      <BenefitBox
        image="more-health.png"
        text={translation.benefitMoreHealth}
        desktopTop={0}
        desktopLeft={710}
        textBoxWidth={320}
        desktopTextBoxLeft={-150}
        desktopTextBoxTop={28}
      />
      <BenefitBox
        image="areas.png"
        text={translation.benefitAreas}
        desktopTop={168}
        desktopLeft={-40}
        textBoxWidth={371}
        desktopTextBoxLeft={600}
        desktopTextBoxTop={370}
      />
      <BenefitBox
        image="health-sequences.png"
        text={translation.benefitHealthSequences}
        desktopTop={564}
        desktopLeft={1010}
        textBoxWidth={340}
        desktopTextBoxLeft={200}
        desktopTextBoxTop={370}
      />
      <BenefitBox
        image="achieve-goal.png"
        text={translation.benefitMoreAchieveGoal}
        desktopTop={733}
        desktopLeft={270}
        textBoxWidth={290}
        desktopTextBoxLeft={700}
        desktopTextBoxTop={370}
      />
    </Wrapper>
  </Layout>
);

const Layout = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${desktopQuery`
    height: 1333px;
  `}
`;

const Wrapper = styled.div`
  ${desktopQuery`
    position: relative;
    width: 2069px;
    height: 100%;
  `}
`;

const BenefitBox: React.FC<{
  image: string;
  text: string;
  desktopTop: number;
  desktopLeft: number;
  textBoxWidth: number;
  desktopTextBoxTop: number;
  desktopTextBoxLeft: number;
}> = (props) => {
  const deviceWidth = useDeviceWidthQuery();
  return (
    <div
      style={
        deviceWidth === DeviceWidth.desktop
          ? {
              position: "absolute",
              left: props.desktopLeft,
              top: props.desktopTop,
            }
          : {
              position: "relative",
              paddingBottom: 35,
            }
      }
    >
      <BenefitImage src={`/home/benefits/${props.image}`} />
      <div
        style={{
          position: "absolute",
          top:
            deviceWidth === DeviceWidth.desktop
              ? props.desktopTextBoxTop + 20
              : 160,
          left:
            deviceWidth === DeviceWidth.desktop
              ? props.desktopTextBoxLeft + 20
              : 35,
          width: props.textBoxWidth,
        }}
      >
        <SlantedSection
          offset={0}
          height={deviceWidth === DeviceWidth.desktop ? 104 : 70}
          width={props.textBoxWidth}
          justifyContent="center"
          alignItems="center"
          color="white"
          skewLeft={true}
        >
          <BenefitText>{props.text}</BenefitText>
        </SlantedSection>
      </div>
    </div>
  );
};

const BenefitImage = styled.img`
  width: 1033px;
  height: 500px;
  padding: 20px;

  ${mobileQuery`
    width: 455px;
    height: 220px;
    padding: 10px;
  `}
`;

const BenefitText = styled.h1`
  font-size: 24px;
  font-weight: bold;
  background: ${primaryGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0px;
  padding-left: 30px;
  padding-right: 20px;

  ${mobileQuery`
    font-size: 16px;
  `}
`;
